<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="title" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="f-16 f-regular f-c-black md-content" v-if="!isFetching">
                    <div class="wrapper-list" :class="{ active: isActive(null) }" v-if="showAll">
                        <div
                            class="d-flex-between-center"
                            @click="
                                selected({
                                    nama: 'Semua perangkat',
                                    nomor: null,
                                    iddevice: null,
                                    country_code: `62`,
                                })
                            "
                        >
                            <div>
                                <p class="m-d-0 f-16 f-semi f-c-black f-cont">
                                    Semua perangkat
                                </p>
                            </div>
                            <div>
                                <IconBased width="16" height="16" v-if="isActive(null)">
                                    <template v-slot:icons>
                                        <RadioCheckedBlue />
                                    </template>
                                </IconBased>
                                <IconBased width="16" height="16" v-else>
                                    <template v-slot:icons>
                                        <RadioUnChecked />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                    </div>
                    <div
                        class="wrapper-list"
                        v-for="(list, idx) in listDeviceTiny"
                        :key="`d-wa-${idx}`"
                        :class="{ active: isActive(list.iddevice) }"
                    >
                        <div class="d-flex-between-center" @click="selected(list)">
                            <div>
                                <p class="m-d-0 f-16 f-semi f-c-black f-cont">
                                    {{ list.nama }}
                                </p>
                                <p class="m-d-0 f-14 f-regular f-c-midgrey">
                                    +{{ list.country_code }}{{ list.number }}
                                </p>
                            </div>
                            <div>
                                <IconBased width="16" height="16" v-if="isActive(list.iddevice)">
                                    <template v-slot:icons>
                                        <RadioCheckedBlue />
                                    </template>
                                </IconBased>
                                <IconBased width="16" height="16" v-else>
                                    <template v-slot:icons>
                                        <RadioUnChecked />
                                    </template>
                                </IconBased>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import IconBased from "../../components/iconPack/IconBased.vue";
import RadioUnChecked from "../iconPack/RadioUnChecked1616.vue";
import RadioCheckedBlue from "../iconPack/RadioCheckedBlue1616.vue";

import { moduleName } from "../../store/state";

export default {
    name: "PilihPerangkatOutlet",
    components: {
        SOSlotModal,
        IconBased,
        RadioUnChecked,
        RadioCheckedBlue,
    },
    data() {
        return {
            defaultDevice: null,
            backLink: "wa_autosender.detail_perangkat.daftar_oulet",
            modalId: "pilih-perangkat",
            title: "Perangkat WA",
            showAll: true,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "wa_autosender.detail_perangkat.daftar_oulet.switch_perangkat") {
                vm.setBackLink("wa_autosender.detail_perangkat.daftar_oulet.set_draft");
                vm.setShowAll(false);
                vm.setTitle("Pindah perangkat");
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.init();

    },
    computed: {
        ...mapGetters(moduleName, {
            listDeviceTiny: "listDeviceTiny",
            integrasiOulet: "integrasiOulet",
            response: "response",
            isFetching: "isFetching",
            device: "device",
        }),
        isActive() {
            return (deviceId) => {
                return this.device.iddevice === deviceId ? true : false;
            };
        },
    },
    methods: {
        ...mapActions({
            getListDeviceTiny: `${moduleName}/getListDeviceTiny`,
            setDevice: `${moduleName}/setDevice`,
        }),
        init() {
            if (this.listDeviceTiny.length === 0) {
                this.getListDeviceTiny();
            }

            this.defaultDevice = this.device.iddevice;
        },
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        setBackLink(val) {
            this.backLink = val;
        },
        setTitle(val) {
            this.title = val;
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setShowAll(val) {
            this.showAll = val;
        },
        async selected(val) {
            await this.setDevice({ type: "iddevice", data: val.iddevice });
            await this.setDevice({ type: "nama", data: val.nama });
            await this.setDevice({ type: "nomor", data: val.number });
            await this.setDevice({ type: "country_code", data: val.country_code });
            if (this.backLink === "wa_autosender.detail_perangkat.daftar_oulet.set_draft") {
                await this.$router.push({
                    name: "wa_autosender.detail_perangkat.daftar_oulet.confirm_switch_perangkat",
                    query: { defaultDevice: this.defaultDevice },
                });
            } else {
                await this.back();
            }
        },
    },
};
</script>
<style scoped>
.md-content {
    max-height: 50vh;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-left: -20px;
    margin-right: -20px;
}
.p-x-2 {
    padding-left: 2px;
    padding-right: 2px;
}
.wrapper-list {
    padding: 12px 20px;
}
.active {
    background-color: #edf5ff;
}
.cs-name {
    display: block;
}
</style>
